import { authInstance } from "services/firebase/FirebaseService";
import { authentication } from "./authentication/authentication";

export const AuthService = authentication(authInstance);
